/**
 * MQTT Configuration
 */
export const MQTT_CONFIG = {
  broker: 'wss://aquamonitor.org/mqtt',
  username: 'raspberry',
  password: 'Raspberry2025!',
  topic: 'datos/#',
  clientIdPrefix: 'aqua-dashboard',
  reconnectPeriod: 5000,
  connectTimeout: 30000,
};

/**
 * Connection check interval in milliseconds
 */
export const MESSAGE_TIMEOUT = 30000;
export const CONNECTION_CHECK_INTERVAL = 3000;
